import { IndexedDB_Database } from './IndexedDB_Database.js';
import { IndexedDB_Store } from './IndexedDB_Store.js';
export class ModuleFE_IDBManager_Class {
    databases = {};
    register(dbConfig, onDBOpenCallback) {
        const indexDb = this.databases[dbConfig.group] || (this.databases[dbConfig.group] = new IndexedDB_Database(dbConfig.group));
        indexDb.registerStore(dbConfig, onDBOpenCallback);
        return new IndexedDB_Store(dbConfig, this.storeResolver, this.storeExistsResolver);
    }
    storeResolver = async (dbConfig, write = false, store) => {
        const dbWrapper = this.databases[dbConfig.group];
        return dbWrapper.getStore(dbConfig, write, store);
    };
    storeExistsResolver = async (dbConfig) => {
        const dbWrapper = this.databases[dbConfig.group];
        return await dbWrapper.storeExists(dbConfig.name);
    };
}
export const ModuleFE_IDBManager = new ModuleFE_IDBManager_Class();
//# sourceMappingURL=ModuleFE_IDBManager.js.map